import { Modal, Button as AntButton } from "antd";
import React from "react";
import { CheckOutlined } from "@ant-design/icons";
import styles from "./index.module.scss";

export interface CaModalListItem {
  icon: string;
  label: string;
  desc: string;
  buttonLabel?: string;
  clickFunc: () => void;
  ribbon?: string;
  price?: string;
  id: string;
}

interface CaModalProps {
  open: boolean;
  onCancel: () => void;
  title?: string;
  list: CaModalListItem[];
  width?: number;
  footer?: React.ReactNode;
  showCancel?: boolean;
  onCancelBtnClick?: () => void;
  needSelect?: boolean;
}

const CaModal = ({
  open,
  onCancel,
  title = "您还可以选择：",
  list,
  width = 520,
  footer = null,
  showCancel = false,
  onCancelBtnClick,
  needSelect = true,
}: CaModalProps) => {
  const [selectItem, setSelectItem] = React.useState<CaModalListItem | null>(
    null,
  );

  const type = !!list[0]?.buttonLabel ? "default" : "outline";

  return (
    <Modal
      title={<span className={styles.modalTitle}>{title}</span>}
      centered
      width={width}
      open={open}
      onCancel={onCancel}
      footer={type === "default" ? footer : undefined}
      okText={"去认证"}
      cancelText={"跳过，去报名"}
      cancelButtonProps={{
        style: { display: showCancel ? undefined : "none" },
        onClick: onCancelBtnClick,
      }}
      wrapClassName={styles.modalWrap}
    >
      {list.map((item, index) => {
        const isRecommend = !!item.ribbon;
        return (
          <div
            key={index}
            className={
              isRecommend ? styles.modalCardRecommend : styles.modalCard
            }
            style={{
              cursor: "pointer",
              backgroundColor:
                item?.id === selectItem?.id
                  ? "rgba(255, 86, 0, 0.06)"
                  : "transparent",
              borderColor: item?.id === selectItem?.id ? "#ff5600" : undefined,
            }}
            onClick={() => {
              if (needSelect) {
                setSelectItem(item);
              }
            }}
          >
            {item?.id === selectItem?.id && (
              <span className={styles.modalCardCheck}>
                <CheckOutlined />
              </span>
            )}
            {item.ribbon && (
              <span className={styles.modalCardRibbon}>{item.ribbon}</span>
            )}
            <img src={item.icon} className={styles.modalCardIcon} />
            <div className={styles.modalCardContent}>
              <div className={styles.modalCardTitle}>
                {item.label}
                {item.price && (
                  <span className={styles.modalCardPrice}>{item.price}</span>
                )}
              </div>
              <div className={styles.modalCardDesc}>{item.desc}</div>
            </div>
            {item.buttonLabel && (
              <AntButton
                type={isRecommend ? "primary" : undefined}
                className={
                  isRecommend ? styles.modalBtnPrimary : styles.modalBtnOutline
                }
                onClick={item.clickFunc}
              >
                {item.buttonLabel}
              </AntButton>
            )}
          </div>
        );
      })}
    </Modal>
  );
};

export default CaModal;
